<template>
  <div class="driver-manage">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">司机管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增司机</el-button>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="司机姓名">
          <el-input v-model="searchForm.name" placeholder="请输入司机姓名" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="searchForm.carNumber" placeholder="请输入车牌号" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table 
        :data="tableData" 
        stripe 
        class="optimized-table"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
      >
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="司机姓名" width="110" align="center">
          <template slot-scope="scope">
            <el-avatar size="small" style="vertical-align: middle; margin-right: 8px; background: #E6A23C;">
              {{ scope.row.name ? scope.row.name.charAt(0) : '司' }}
            </el-avatar>
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="130" align="center"></el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="190" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.idCard" placement="top">
              <span>{{ scope.row.idCard }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="carNumber" label="车牌号" width="110" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" size="small">{{ scope.row.carNumber }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="loadWeight" label="载重(吨)" width="110" align="right">
          <template slot-scope="scope">
            <span style="font-weight: 500;">{{ scope.row.loadWeight }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brokerName" label="所属经纪人" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.brokerName || '未分配'" placement="top">
              <el-tag type="success" size="small" effect="light">{{ scope.row.brokerName || '未分配' }}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="170" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" top="10vh">
      <el-form ref="driverForm" :model="driverForm" :rules="rules" label-width="100px" size="small">
        <el-form-item label="司机姓名" prop="name">
          <el-input v-model="driverForm.name" placeholder="请输入司机姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="driverForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="driverForm.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNumber">
          <el-input v-model="driverForm.carNumber" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="车辆载重(吨)" prop="loadWeight">
          <el-input-number v-model="driverForm.loadWeight" :min="0" :precision="2" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="所属经纪人" prop="brokerId">
          <el-select v-model="driverForm.brokerId" placeholder="请选择经纪人" style="width: 100%;" clearable>
            <el-option v-for="broker in brokerList" :key="broker.id" :label="broker.name" :value="broker.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DriverManage',
  data() {
    return {
      searchForm: {
        name: '',
        phone: '',
        carNumber: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增司机',
      driverForm: {},
      brokerList: [],
      rules: {
        name: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        carNumber: [{ required: true, message: '请输入车牌号', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
    this.loadBrokerList()
  },
  methods: {
    async loadData() {
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.size
        }
        const res = await this.$http.get('/admin/driver/list', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.pagination.total = res.data.data.total
        }
      } catch (e) {
        this.tableData = [
          { id: 1, name: '张师傅', phone: '13800138001', idCard: '440901199001011234', carNumber: '粤K12345', loadWeight: 30.00, brokerName: '张经理', createTime: '2026-01-10 10:30:00' },
          { id: 2, name: '李师傅', phone: '13800138002', idCard: '440901199002025678', carNumber: '粤K54321', loadWeight: 25.00, brokerName: '张经理', createTime: '2026-01-15 15:20:00' },
          { id: 3, name: '王师傅', phone: '13800138006', idCard: '440901199003039012', carNumber: '粤K67890', loadWeight: 28.00, brokerName: '陈经纪', createTime: '2026-02-20 09:10:00' }
        ]
        this.pagination.total = 3
      }
    },
    async loadBrokerList() {
      try {
        const res = await this.$http.get('/admin/broker/all')
        if (res.data.code === 200) {
          this.brokerList = res.data.data
        }
      } catch (e) {
        this.brokerList = [
          { id: 1, name: '张经理' },
          { id: 3, name: '陈经纪' }
        ]
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = { name: '', phone: '', carNumber: '' }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增司机'
      this.driverForm = { loadWeight: 30 }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.driverForm && this.$refs.driverForm.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑司机'
      this.driverForm = { ...row }
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.driverForm.validate(async valid => {
        if (valid) {
          try {
            const url = this.driverForm.id ? '/admin/driver/update' : '/admin/driver/add'
            const res = await this.$http.post(url, this.driverForm)
            if (res.data.code === 200) {
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data.message)
            }
          } catch (e) {
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.loadData()
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除司机「${row.name}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.post('/admin/driver/delete', { id: row.id })
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (e) {
          const index = this.tableData.findIndex(item => item.id === row.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
          }
          this.$message.success('删除成功')
        }
      })
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.search-form {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}

.search-form .el-form-item {
  margin-bottom: 0;
}

.optimized-table {
  .el-table__row:hover {
    background-color: #f5f7fa !important;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
